export class TrackingVO {
	public lessonStatus: string;
	public initialLessonLocation: string;
	public lessonLocation: string;
	public suspendData: string;
	public totalTime: string;
	public sessionTime: string;
	public elt_total_time: string;
	public geoLocation: string;
	public score: number = 0;
	public quizScore: number;
	public completionDate: number;
	public bookmark: string;
	public studentName: string;
	public studentId: string;
	public aicc_url: string;
	public aicc_sid: string;
	public clientId: string;
	public clientKey: string;
	public interactionCount: number;
	public opProfile: string;
	public attempts: any[];
	public failure: any[];
	public penmanName: string;
	public complianceTypeID: string;
	public complianceTypeName: string;
	public courseTopic: string;
	public learningType: string;
	public moduleVersion: string;
	public accessabilityOption: string;
	public moduleShortname: string;
	public totalScore: number;
	public rubricStatus: string;
	public currentModuleScore: number;
	public currentModuleMaxScore: number;
	public moduleScore: string;
	public maxModuleScore: string;
	public maxTotalScore: number;
}
